import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadRodoTerms} from "../../../application/components/LeadRodoTerms";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {setRegistrationMethod} from "../../state/registration_flow_slice";
import {AmplitudeAuthLocation} from "../../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../../types/AuthActionType";
import {ConsistentRegisterForm} from "./ConsistentRegisterForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
}

export const RegisterAndDownloadPlanCard = (props: IProps) => {
    const {onAuthSuccess, onSwitchToLogin, userSource, gtmSourceSection, title, gtmEventData, wrapperClassName, amplitudePlacement, amplitudeLocation} = props;
    const dispatch = useAppDispatch();

    const socialAuthSuccess = () => {
        dispatch(setRegistrationMethod({method: "social"}));
        onAuthSuccess(AuthActionType.REGISTRATION);
    };

    const emailAuthSuccess = () => {
        dispatch(setRegistrationMethod({method: "email"}));
        onAuthSuccess(AuthActionType.REGISTRATION);
    };

    return (
        <div className={cx(wrapperStyle, wrapperClassName)}>
            {title}

            <SocialAuth
                onAuthSuccess={socialAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                amplitudeLocation={amplitudeLocation}
                authContext="registration"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <ConsistentRegisterForm
                onAuthSuccess={emailAuthSuccess}
                gtmEventData={gtmEventData}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                amplitudeLocation={amplitudeLocation}
            />

            <div className={loginSectionStyle}>
                <Text variant="info_txt_1" align="center">
                    Masz już konto?
                </Text>

                <Button onClick={onSwitchToLogin} variant="highlight_primary" dataTestId={OFFER_TEST_IDS.REGISTER_FORM.GO_TO_LOGIN_FORM_BUTTON}>
                    ZALOGUJ SIĘ
                </Button>
            </div>

            <div className={leadTermsStyle}>
                <LeadRodoTerms align="center" />
            </div>
        </div>
    );
};

const wrapperStyle = css({
    width: "100%",
    backgroundColor: "#fff",
    padding: 1.5,
    md: {
        padding: 3
    }
});

const separatorTextStyle = css({
    paddingY: 1.5,
    marginTop: 1.5,
    textAlign: "center"
});

const loginSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    position: "relative",
    paddingTop: 3,
    paddingBottom: 1.5
});

const leadTermsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    textAlign: "center"
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {LeadRodoTerms} from "../../../application/components/LeadRodoTerms";
import {useAppDispatch} from "../../../store/hooks";
import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AmplitudeAuthPlacement} from "../../../tracking/types/AmplitudeAuthPlacement";
import {setRegistrationMethod} from "../../state/registration_flow_slice";
import {AmplitudeAuthLocation} from "../../tracking/track_amplitude_auth_event";
import {AuthActionType} from "../../types/AuthActionType";
import {ConsistentRegisterForm} from "./ConsistentRegisterForm";
import {SocialAuth} from "./SocialAuth";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
    amplitudePlacement?: AmplitudeAuthPlacement | null;
    amplitudeLocation?: AmplitudeAuthLocation;
}

export const RegisterAndDownloadPlanCard = (props: IProps) => {
    const {onAuthSuccess, onSwitchToLogin, userSource, gtmSourceSection, title, gtmEventData, wrapperClassName, amplitudePlacement, amplitudeLocation} = props;
    const dispatch = useAppDispatch();

    const socialAuthSuccess = () => {
        dispatch(setRegistrationMethod({method: "social"}));
        onAuthSuccess(AuthActionType.REGISTRATION);
    };

    const emailAuthSuccess = () => {
        dispatch(setRegistrationMethod({method: "email"}));
        onAuthSuccess(AuthActionType.REGISTRATION);
    };

    return (
        <div className={cx(wrapperStyle, wrapperClassName)}>
            {title}

            <SocialAuth
                onAuthSuccess={socialAuthSuccess}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                amplitudeLocation={amplitudeLocation}
                authContext="registration"
            />

            <Text align="center" className={separatorTextStyle} variant="info_txt_1">
                Lub zarejestruj się
            </Text>

            <ConsistentRegisterForm
                onAuthSuccess={emailAuthSuccess}
                gtmEventData={gtmEventData}
                userSource={userSource}
                gtmSourceSection={gtmSourceSection}
                amplitudePlacement={amplitudePlacement}
                amplitudeLocation={amplitudeLocation}
            />

            <div className={loginSectionStyle}>
                <Text variant="info_txt_1" align="center">
                    Masz już konto?
                </Text>

                <Button onClick={onSwitchToLogin} variant="highlight_primary" dataTestId={OFFER_TEST_IDS.REGISTER_FORM.GO_TO_LOGIN_FORM_BUTTON}>
                    ZALOGUJ SIĘ
                </Button>
            </div>

            <div className={leadTermsStyle}>
                <LeadRodoTerms align="center" />
            </div>
        </div>
    );
};

const wrapperStyle = css({
    width: "100%",
    backgroundColor: "#fff",
    padding: 1.5,
    md: {
        padding: 3
    }
});

const separatorTextStyle = css({
    paddingY: 1.5,
    marginTop: 1.5,
    textAlign: "center"
});

const loginSectionStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 0.5,
    position: "relative",
    paddingTop: 3,
    paddingBottom: 1.5
});

const leadTermsStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    textAlign: "center"
});
